import React from "react"
import Typography from '@mui/material/Typography';
//import ArrowRightIcon from '@mui/icons-material/ArrowRight';

export const TextSignalMono = () => {

return(
<div>
    
<Typography variant="h6" >

Approx. 30 monogenetic (rare) variants were tested regarding monogenetic syndromes.<br /><br />
There were no major (pathogenic) findings.


 
</Typography>

</div>
)
}